import * as types from "../actions/constants";

interface IProductsAction {
  type: string;
  payload?: { data: unknown[] };
}

const productsReducer = (state: unknown[] = [], action: IProductsAction) => {
  switch (action.type) {
    case types.LOAD_PRODUCTS_SUCCESS:
      return action.payload.data;
    default:
      return state;
  }
};

export default productsReducer;
